import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import { Link, useLocation } from 'react-router-dom';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { getAuth, signOut } from 'firebase/auth';
import ComingSoonModal from './ComingSoonModal';
import LogoutSuccessModal from './AlertComponents/LogoutSuccessModal';
import { useUser } from '../context/UserContext';
import { POLICY_NAV_LABEL } from '../constants/policyLabels';
import '../styles/component_styles/TopMenu.scss';

function TopMenu() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const location = useLocation();

  const { user } = useUser();

  const isActive = (to) => {
    if (to === '/') return location.pathname === '/';
    return location.pathname === to || location.pathname.startsWith(to + '/');
  };

  const close = () => setMenuOpen(false);

  const handleLogout = async () => {
    close();
    try {
      await signOut(getAuth());
      setShowLogoutModal(true);
    } catch (err) {
      console.error('Logout error:', err);
    }
  };

  const isLoggedIn = user && user !== undefined;

  // Hydration-safe gating: render the logged-out "Elections" CTA on first
  // paint (matches the prerendered HTML), then hide it once Firebase resolves
  // a logged-in user via useEffect after mount. Avoids React 18 hydration
  // warnings for prerendered marketing routes.
  const [hideElectionsCta, setHideElectionsCta] = useState(false);
  useEffect(() => {
    setHideElectionsCta(Boolean(isLoggedIn));
  }, [isLoggedIn]);

  const navLinks = [
    ...(!hideElectionsCta
      ? [{ to: '/elections', label: 'Election Lookup' }]
      : []),
    ...(isLoggedIn ? [{ to: '/dashboard', label: 'Dashboard' }] : []),
    { to: '/community', label: 'Community' },
    { to: '/discover', label: 'Discover' },
    { to: '/bills', label: POLICY_NAV_LABEL },
    { to: '/events', label: 'Events' },
    { to: '/features', label: 'Features' },
  ];

  return (
    <>
      <nav className={`app__nav${menuOpen ? ' app__nav--menu-open' : ''}`}>
        <Container fluid className="app__nav-container">
          <Link to="/" className="app__nav-brand" onClick={close}>
            <span className="app__brand-civix">Civix</span>
            <span className="app__brand-thread">Thread</span>
          </Link>

          <button
            className="custom-toggler"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="Toggle navigation"
          >
            {menuOpen ? (
              <CloseRoundedIcon fontSize="inherit" />
            ) : (
              <MenuRoundedIcon fontSize="inherit" />
            )}
          </button>

          <div className={`app__nav-links${menuOpen ? ' app__nav-links--open' : ''}`}>
            <div className="app__nav-links-main">
              {navLinks.map(({ to, label }) => (
                <Link
                  key={to}
                  to={to}
                  onClick={close}
                  className={`app__nav-link app__nav-link--animated-underline${isActive(to) ? ' app__nav-link--active' : ''}`}
                >
                  {label}
                </Link>
              ))}
            </div>

            <div className="app__nav-links-actions">
              {/* Donate – hidden from top nav for now (footer link remains)
              <Link
                to="/donate"
                onClick={close}
                className={`app__nav-link app__nav-link--outline${isActive('/donate') ? ' app__nav-link--active' : ''}`}
              >
                Donate
              </Link>
              */}
              {isLoggedIn ? (
                <button
                  onClick={handleLogout}
                  className="app__nav-link app__nav-link--login"
                >
                  Log Out
                </button>
              ) : (
                <Link
                  to="/auth/login"
                  onClick={close}
                  className="app__nav-link app__nav-link--cta"
                >
                  Login
                </Link>
              )}
              {/* Get the App – commented out
              <button onClick={handleGetAppClick} className="app__nav-link app__nav-link--cta">
                <PhoneIphoneRoundedIcon sx={{ fontSize: '1.1rem' }} />
                Get the App
              </button>
              */}
            </div>
          </div>
        </Container>
      </nav>

      <ComingSoonModal open={showModal} onClose={() => setShowModal(false)} />
      <LogoutSuccessModal
        open={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
      />
    </>
  );
}

export default TopMenu;
